import React from "react";
import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";



export default function PlantaBenficiamento(){

  return(

    <>
    <Helmet title="Planta e Beneficiamento - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="PLANTA E BENEFICIAMENTO" link1={"Projetos/ "} link2={"PLANTA E BENEFICIAMENTO"} />
      <section id="context">
        <div className="container">

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                    Projeto Sossego Planta de Beneficiamento
                </h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Prestação de serviço com fornecimento de mão de obra para execução de atividades operacionais da planta de beneficiamento (britagem, peneiramento, amostragem e classificação a seco de minério), transporte e carregamento de minério, e manutenção industrial na Mina do Sossego da VALE, em Canaã dos Carajás – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0"
            >
                <h2>Informações do Projeto</h2>
                <ul>
                  <li><strong>Cliente: </strong> Vale</li>
                  <li><strong>Cidade: </strong> Canaã dos Carajás - PA</li>
                  <li><strong>Ano: </strong> 2021 </li>
                  <li><strong>Segmento: </strong> Obra Civil </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />

      <Ouvidoria/>
    </>
  )
}